import { render, staticRenderFns } from "./framework.vue?vue&type=template&id=08e2cba6"
import script from "./framework.vue?vue&type=script&lang=js"
export * from "./framework.vue?vue&type=script&lang=js"
import style0 from "./framework.vue?vue&type=style&index=0&id=08e2cba6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e2cba6')) {
      api.createRecord('08e2cba6', component.options)
    } else {
      api.reload('08e2cba6', component.options)
    }
    module.hot.accept("./framework.vue?vue&type=template&id=08e2cba6", function () {
      api.rerender('08e2cba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/companyCustomerManage/framework.vue"
export default component.exports